import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Pagination, Text } from "@mantine/core";
import { scrollToContainerTop } from "../utils/Scroll.utils";
export const TablePagination = ({ count = 0, page, setPage }) => {
    return (_jsxs(Flex, { justify: "space-between", align: "center", children: [_jsx("div", {}), _jsx(Pagination, { value: page, total: count ? Math.ceil(count / 100) : 0, onChange: (value) => {
                    setPage(value);
                    scrollToContainerTop("scrollableContainer");
                } }), count && (_jsx(Text, { variant: "body", style: { textAlign: "right", marginRight: "1rem" }, children: `Total: ${count}` }))] }));
};
